// censors/vm-form
import { useLoadingAction } from 'src/hooks/use-actions';
import { apiTmsUpdate, apiSendTms } from './data-form';
import { apiSendRepair, apiUnsendRepair } from './data-form';

const useForms = () => {
  // Tms
  const updateTmsItem = (payload, onSuccess, onError) => useLoadingAction(apiTmsUpdate, payload, onSuccess, onError);
  const sendTmsTicket = (payload, onSuccess, onError) => useLoadingAction(apiSendTms, payload, onSuccess, onError);
  
  // Repair
  const sendRepairTicket = (payload, onSuccess, onError) => useLoadingAction(apiSendRepair, payload, onSuccess, onError);
  const unsendRepairTicket = (payload, onSuccess, onError) => useLoadingAction(apiUnsendRepair, payload, onSuccess, onError);
  
  return {
    updateTmsItem,
    sendTmsTicket,
    sendRepairTicket,
    unsendRepairTicket,
  };
};

export default useForms;
